import { Heart, Home, MapPin } from "lucide-react";

const ITEMS = [
  {
    icon: Heart,
    title: "Woman-Founded",
    body: "Built and led by Kay herself — a brand that stands out and shows up.",
  },
  {
    icon: Home,
    title: "Family-Owned",
    body: "A tight-knit team who genuinely care about doing the job right for you.",
  },
  {
    icon: MapPin,
    title: "Proudly Local",
    body: "Based in the South West, serving our neighbours across Somerset & Bristol.",
  },
];

export default function WhyUs() {
  return (
    <section id="why" className="border-b-2 border-black bg-white">
      <div className="mx-auto max-w-7xl px-4 py-20 md:px-8 md:py-28">
        <div className="mb-10 flex flex-col items-start justify-between gap-6 md:mb-14 md:flex-row md:items-end">
          <div>
            <div className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-[var(--kay-pink)]">
              Why Choose Kay's
            </div>
            <h2 className="font-display text-4xl uppercase leading-none sm:text-5xl md:text-6xl">
              Not your average
              <br />
              <span className="text-[var(--kay-pink)]">waste crew.</span>
            </h2>
          </div>
          <p className="max-w-md text-base text-neutral-600">
            We're a small local business that treats every collection like it's
            for a friend. Friendly faces, fair prices, no messing about.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={i}
                className="group border-2 border-black bg-white p-6 hard-shadow hover-lift"
              >
                <div className="mb-6 inline-flex h-12 w-12 items-center justify-center border-2 border-black bg-[var(--kay-pink)] text-black">
                  <Icon size={22} />
                </div>
                <h3 className="font-display text-2xl uppercase tracking-tight">
                  {it.title}
                </h3>
                <p className="mt-3 text-neutral-600">{it.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
